// extracted by mini-css-extract-plugin
export default {"autoSuggestions":"AutoSuggestions_autoSuggestions__g-ELw"};